/* eslint-disable no-magic-numbers */
import { NgClass } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NumberSeparatorPipe } from '@shared/pipe.number-separator';
import { ContentPromo } from '../content-promo-detail/content-promo-detail';

@Component({
  selector: 'app-footer-promo-detail',
  standalone: true,
  imports: [NgClass, NumberSeparatorPipe, TranslatePipe],
  templateUrl: './footer-promo-detail.component.html',
  styleUrl: './footer-promo-detail.component.scss'
})
export class FooterPromoDetailComponent {
  data = input<ContentPromo>();
  buy = output<void>();

  currentHeight = 0;

  onClickBuy() {
    this.buy.emit();
  }
}
